import { t } from "@travily/i18n";
import { Icon } from "@ui/components/Icon";
import { ToggleTile } from "@ui/components/ToggleTile";
import { RECOMMENDED_FILTERS, type RecommendedFilterKey } from "../constants";

export interface RecommendedFiltersProps {
  onChange: (key: RecommendedFilterKey, value: boolean) => void;
  values: Record<RecommendedFilterKey, boolean>;
}

export function RecommendedFilters({ onChange, values }: RecommendedFiltersProps) {
  return (
    <div className="grid grid-cols-4 gap-4">
      {RECOMMENDED_FILTERS.map((filter) => (
        <ToggleTile
          color={filter.color}
          icon={<Icon name={filter.icon} type="sticker" />}
          isSelected={values[filter.key]}
          key={filter.key}
          label={t(filter.labelKey)}
          onChange={(value) => onChange(filter.key, value)}
          orientation="vertical"
        />
      ))}
    </div>
  );
}
